export class OverlayContentStyle {
  size = 'uk-h5';
  font = 'tb-font-primary';
  marginTop = 'uk-margin-top';
  transition = '';

  static normalize(styles: Partial<OverlayContentStyle>): OverlayContentStyle {
    const pureStyles = new OverlayContentStyle();

    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.font = styles.font ?? pureStyles.font;
    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;
    pureStyles.transition = styles.transition ?? pureStyles.transition;

    return pureStyles;
  }
}
